export const frameTypes = ['wall', 'beam'] as const;
